module.exports = __webpack_public_path__ + "img/icon_map_64_on.102e66dc.png";